import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { candidateInvite } from "../redux/thunks/Auth";
import { isWhiteLabelClient } from "../utils/utilities";
import Button from "../components/sub-component/Button";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import { ReactComponent as TestFuseWatermarkIcon } from "../assets/icons/candidate-assessment/Watermark Light.svg";

function AssessmentUnavailable({ isVisible }) {
  const dispatch = useDispatch();
  const [isloading, setIsLoading] = useState(true);
  const [inviteData, setInviteData] = useState(null);
  const [processing, setProcessing] = useState(false);
  const invite_id = localStorage.getItem("invite_id");

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      const valid = await dispatch(candidateInvite({ invite_id: invite_id }));
      setInviteData(valid?.payload);
      setIsLoading(false);
      // localStorage.removeItem("invite_id");
    };

    fetchData();
  }, []);

  return (
    <>
      {alert}
      {isloading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProcessingIndicator />
        </div>
      ) : (
        <div className="candidate-invite-main-container">
          <div className="candidate-invite-container">
            {!isWhiteLabelClient() && (
              <div className="assessment-header">
                {inviteData?.tenant_logo ? (
                  <img
                    className="assessment-header-icon"
                    src={inviteData?.tenant_logo}
                    alt=""
                  />
                ) : (
                  <div className="assessment-header-icon-initial">
                    <span className="body-1 white">
                      {(
                        inviteData?.tenant_name?.slice(0, 2) || ""
                      ).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="headline-1 dark-100">
                  {inviteData?.tenant_name}
                </span>
              </div>
            )}
            <span className="headline-3 text-start">
              Assessment Unavailable
            </span>
            <span className="body-2 dark-50 text-start">
              {`We're sorry, but the assessment you are trying to access is no
                longer available. This could be due to various reasons, such as
                the assessment period has ended or it has been withdrawn.`}
            </span>
            <span className="body-2 dark-50 text-start">
              If you have any questions or concerns, please feel free to contact
              our support team for assistance..
            </span>
            {!isWhiteLabelClient() && (
              <form className="w-100">
                {isVisible && (
                  <div>
                    <Button
                      btn="ragular-btn"
                      varrient="primary"
                      textClass="body-1"
                      processing={processing}
                      type={"submit"}
                      title={"Go To DashBoard"}
                      style={{ width: "100%", height: "40px" }}
                    />
                  </div>
                )}
              </form>
            )}
          </div>
          {!isWhiteLabelClient() && (
            <div className="watermark mt-3">
              <TestFuseWatermarkIcon style={{ height: "50px" }} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default AssessmentUnavailable;
